import Chat from '@/components/chat';
import { ChatProvider, useChat } from '@/contexts/chat-context';
import { SocketEvent } from '@/types/socket';
import { useAuthStore } from '@/store/useAuthStore';
import { AiEmailAssistantForm } from '@/schemas/ai-email-assistant';
import { useEffect, useRef } from 'react';

export const ChatTivy = (formData: AiEmailAssistantForm) => {
  const { user } = useAuthStore();

  const DEFAULT_PARAMETERS = [
    { key: 'userId', value: user.id },
    { key: 'messageType', value: formData.messageType ?? '' },
    { key: 'donorContext', value: formData.donorContext ?? '' },
    { key: 'organizationContext', value: formData.organizationContext ?? '' },
    { key: 'pastConversations', value: formData.pastConversations ?? '' }
  ];

  const conversationConfig = {
    title: 'Tivy Email Assistant',
    type: 'EMAIL_DRAFTER' as const,
    parameters: DEFAULT_PARAMETERS,
    messages: []
  };

  return (
    <ChatProvider
      config={conversationConfig}
      outputEvent={SocketEvent.COACHING_CHAT_RESPONSE}
      inputEvent={SocketEvent.COACHING_CHAT_MESSAGE_STREAM}
    >
      <ChatWithInitialMessage {...formData} />
    </ChatProvider>
  );
};

const ChatWithInitialMessage = (formData: AiEmailAssistantForm) => {
  const initRef = useRef(false);
  const { onSendMessage } = useChat();

  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;

    setTimeout(() => {
      onSendMessage('Please, draft an email based on the shared details.');
    }, 800);
  }, [onSendMessage]);

  return <Chat className="flex-1 border border-cardBorderColor" />;
};
